module.exports = __webpack_public_path__ + "static/build-resilience-bg-f2afe84ad7ec8fbf28d4246de3f29a0d.jpg";